import {
	CHECKOUT_REQUEST,
	CHECKOUT_SUCCESS,
	CHECKOUT_FAIL
} from '../constants/ActionTypes';;

export const checkoutRequest = (values) => {
	return {
		type: CHECKOUT_REQUEST,
		processing: true,
		checkoutFormData: values
	};
};

export const checkoutSuccess = () => {
	return {
		type: CHECKOUT_SUCCESS,
		loading: true
	};
};

export const checkoutFail = () => {
	return {
		type: CHECKOUT_FAIL,
		loading: true
	};
};

